<template>
  <div>
    <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo elementos creados
      </span>
      <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span>
      <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
        <datetime
          v-model="rangeFrom"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="start-time"
        />
        y el
        <datetime
          v-model="rangeUntil"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="end-time"
        />
        <span>
          <vs-button
            radius
            class="ml-3 d-inline"
            color="primary"
            type="border"
            icon="search"
            size="small"
            data-cy="filter-by-date"
            @click="changeFilters(currentFilters)"
          />
        </span>
      </span>
      <vs-dropdown vs-trigger-click style="margin-left: 15px" data-cy="change-date">
        <a class="a-icon" href="#">
          Cambiar
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-dropdown-item
            style="width:200px"
            v-for="range in ranges"
            :key="range.valor"
            data-cy="change-date-item"
            v-on:click.native="selectRange(range)"
          >
            {{ range.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <FiltersAduanas
      :filtersView="filterView"
      :customsCompanies="customsCompanies"
      :periodos="ranges"
      :has-query-filters="!!queryFilters"
      :clear-query-filters="clear"
      v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltersAduanas from '@/febos/global/_vue/componentes/filtersLetty/aduanas/FiltersAduanas';
import ConfigReceiptsFiltersMixin from '@/febos/global/_vue/componentes/filtersLetty/aduanas/ConfigReceiptsFiltersMixin';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { DATE_RANGE_LAST_6_MONTH, DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import { ioGetHoldingCompanies } from '@/febos/servicios/api/v2.companies.api';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';

export default {
  components: { FiltersAduanas },
  props: ['value', 'onChange', 'clear', 'defaultDate'],
  mixins: [ConfigReceiptsFiltersMixin, SelectorDateMixin],
  data() {
    const { name } = this.$route;
    const range = this.defaultDate ? this.defaultDate : DATE_RANGE_LAST_6_MONTH;
    return {
      customsCompanies: [],
      ranges: DATE_RANGES,
      rangeSelected: range,
      rangeFrom: '',
      rangeUntil: '',
      view: name,
      currentFilters: '',
      queryFilters: this.$route.query.filters
    };
  },
  async created() {
    this.selectRange(this.rangeSelected, true);
    this.customsCompanies = [];
    const response = await ioGetHoldingCompanies(
      {
        empresaId: this.company.id,
        params: {
          filtros: 'esGestoria:Y'
        }
      }
    );
    this.customsCompanies = response.data.empresas
      .map((company) => ({
        id: company.empresaId,
        label: company.razonSocial,
        value: company.empresaId
      }));
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany'
    ]),
    configuration() {
      return this.getFilterView(this.view);
    },
    filterView() {
      return this.getFilterView(this.view);
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany'
    ]),
    async changeFilters(filters, onMounted) {
      const rangeFrom = this.$moment(this.rangeFrom).format('YYYY-MM-DD');
      const rangeUntil = this.$moment(this.rangeUntil).format('YYYY-MM-DD');
      const defaultFilters = `fechaCreacion:${rangeFrom}--${rangeUntil}`;
      this.currentFilters = filters;
      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;

      if (!onMounted) {
        const nonShareableFilters = [
          // TODO: agregar campo de busqueda de coincidencias
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}
.search-bar {
  align-items: baseline;
  width: 50%;
}
</style>
